import vp from './vp'

export default {
  addBtn: '添加事件',
  eventDescription:
    '建议不要修改定时器相关数值，否则可能会导致可玩广告无法正常试玩。',
  eventComponent: {
    eventPosition: {
      updatePositionBtn: '位置设置为当前值',
    },
    unit: {
      ShakeFequence: '次/s',
    },
    showElement: '显示素材',
    hideElement: '隐藏素材',
    enablePair: '启用配对关系',
    banPair: '禁用配对关系',
    freeEnable: '启用自由画线组件',
    freeBan: '禁用自由画线组件',
    showGroup: '显示分组',
    hideGroup: '隐藏分组',
    enableEraseGroup: '启用可被擦除分组',
    banEraseGroup: '禁用可被擦除分组',
    enableEraseComponent: '启用擦除组件',
    banEraseComponent: '禁用擦除组件',
    enableMaskComponent: '启用遮罩组件',
    banMaskComponent: '禁用遮罩组件',
    enableMaskGroupComponent: '启用遮罩组',
    banMaskGroupComponent: '禁用遮罩组',
    showMaskGroup: '显示遮罩组',
    hideMaskGroup: '隐藏遮罩组',
    showMaskSubGroup: '显示遮罩分组',
    hideMaskSubGroup: '隐藏遮罩分组',
    enableMaskShape: '启用遮罩效果',
    banMaskShape: '禁用遮罩效果',
    enableCarouselComponent: '启用轮播组件',
    banCarouselComponent: '禁用轮播组件',
    enableCarousel: '启用轮播组',
    banCarousel: '禁用轮播组',
    pauseCarousel: '暂停轮播组',
    playCarousel: '播放轮播组',
  },
  eventBlock: {
    editBtn: '编辑拖拽区域',
    addBtn: '+添加指定区域',
    eventTitle: '响应事件',
    placeholder: '选择响应事件',
    targetTitle: '响应对象',
    targetInfo: '必填信息',
    saveBtn: '保存',
    cancelBtn: '取消',
    addAction: '+ 添加响应事件',
    timerEvent: '计时器',
    jumpToScene: '跳转到指定场景',
    jumpNextScene: '跳转到下一场景',
    jumpAppStore: '跳转应用商店',
    setBuriedPoint: '设置埋点',
    setPosition: '设置位置',
    setSpin: '设置旋转',
    setWidth: '设置宽度',
    setHeight: '设置高度',
    materialDisplay: '显示/隐藏素材',
    setTransparency: '设置透明度',
    setColor: '设置颜色',
    executionDelay: '执行延迟',
    cancelDelay: '取消执行延迟',
    dragDirTitle: '拖拽方向',
    xDragDir: '水平方向',
    yDragDir: '垂直方向',
    anyDragDir: '任意方向',
    dragBound: '拖拽范围',
    dragBoundFullScreen: '全屏',
    dragBoundCustom: '自定义',
    dragBoundCustomDesc: '可在画布中调整大小',
    dragAreaTip: '指定区域',
    dragBoundTip: '自定义拖拽范围',
    dragTip:
      '同一图层，不同拖拽事件下，拖拽相关设置需保持一致，包括：拖拽范围、拖拽方向以最新的设置为准。',
    dragResetPos: '松手是否复位',
    yes: '是',
    no: '否',
  },
  eventHand: {
    click: '点击',
    hold: '长按3s',
    down: '按下',
    up: '抬起',
    doubleClick: '双击',
    swipeUp: '上滑',
    swipeDown: '下滑',
    swipeLeft: '左滑',
    swipeRight: '右滑',
    swipeAny: '任意滑动',
    vpDragStart: '拖拽',
    vpDragPosition: '拖拽到指定位置',
    vpUnDragPosition: '未拖拽到指定位置',
    dragArea: '拖拽指定区域',
    delay: '定时触发',
    customEvent: '自定义事件',
    videoStart: '开始时',
    videoEnd: '结束时',
    audioStart: '开始时',
    audioEnd: '结束时',
    hideUI: '隐藏元素',
    installApp: '下载应用',
    switchScene: '跳转场景',
    fromStatus: '起始状态',
    toStatus: '结束状态',
    longPress: '长按',
    conditionIf: '条件判断',
    drawStart: '开始画线',
    drawEnd: '画线完成',
    freeDrawStart: '开始画线',
    freeDrawEnd: '画线完成',
    eraseStart: '开始擦除',
    eraseUp: '抬手',
    eraseReachStep: '到达某一阶段',
    eraseUnReachStep: '未到达某一阶段',
  },
  eventTarget: {
    placeholder: '选择响应对象',
  },
  visualProgram: {
    variableType: {
      string: '字符串',
      number: '数字',
      boolean: '布尔值',
    },
  },
  action: vp.action,
  VpCategories: vp.VpCategories,
  component: vp.component,
}
